module.exports = __webpack_public_path__ + "img/fox.3bbfd562.png";